"use strict";

var _slicedToArray = require("/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.Portal = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var Portal = function Portal(_ref) {
  var children = _ref.children,
      type = _ref.type;
  var portalNode = React.useRef(null);

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      forceUpdate = _React$useState2[1];

  React.useEffect(function () {
    portalNode.current = document.createElement(type);
    document.body.appendChild(portalNode.current);
    forceUpdate({});
    return function () {
      if (portalNode.current) {
        document.body.removeChild(portalNode.current);
      }
    };
  }, [type]);
  return portalNode.current ? /*#__PURE__*/(0, _reactDom.createPortal)(children, portalNode.current) : null;
};

exports.Portal = Portal;